import React, { useCallback, useEffect, useState } from "react";
import { InputAdornment } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { CalendarIcon } from "./iconography";
import { useListContext } from "ra-core";
import { getDayRange } from "../../utils/dateUtils";

export const ListDatePicker = ({
  label,
  onDateChange,
  onMount,
  onUnmount,
  filterField,
  source,
}) => {
  const { displayedFilters, filterValues, setFilters } = useListContext();
  const [dateValue, setDateValue] = useState(null);

  useEffect(() => {
    if (onMount) {
      onMount();
    }
    return () => {
      const newFilterValues = { ...filterValues };
      const newDisplayedFilters = { ...filterValues };
      delete newFilterValues.and;
      delete displayedFilters.endDateTime;
      setFilters(newFilterValues, newDisplayedFilters);
      setDateValue(null);
      if (onUnmount) {
        onUnmount();
      }
    };
  }, []);

  const handleDateChange = useCallback((value) => {
    if (value) {
      const [startOfDay, endOfDay] = getDayRange(value);
      setFilters(
        {
          ...filterValues,
          and: [
            { [filterField]: { gte: `${startOfDay}` } },
            { [filterField]: { lte: `${endOfDay}` } },
          ],
        },
        displayedFilters
      );
      setDateValue(value);
    } else {
      const newFilterValues = { ...filterValues };
      delete newFilterValues.and;
      setFilters(newFilterValues, displayedFilters);
      setDateValue(null);
    }
    if (onDateChange) {
      onDateChange();
    }
  }, []);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        label={label}
        inputVariant="outlined"
        variant="dialog"
        disableFuture
        margin="dense"
        value={dateValue}
        onChange={handleDateChange}
        onKeyPress={(event) => event.preventDefault()}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarIcon />
            </InputAdornment>
          ),
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
